import { Component, Input } from '@angular/core';
import { transition, trigger, style, state, animate } from '@angular/animations';

@Component({
    selector: 'app-flash-saving',
    templateUrl: './flash-saving.component.html',
    styleUrls: ['./flash-saving.component.scss'],
    animations: [
        trigger('flyInOut', [
            state(
                'in',
                style({
                    transform: 'translateY(0)',
                    opacity: 1,
                })
            ),
            transition('void => *', [
                style({
                    transform: 'translateY(-100%)',
                    opacity: 0,
                }),
                animate(100),
            ]),
            transition('* => void', [
                animate(
                    100,
                    style({
                        transform: 'translateY(-100%)',
                        opacity: 0,
                    })
                ),
            ]),
        ]),
    ],
})
export class FlashSavingComponent {
    @Input() active = false;

    constructor() {}
}
